// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__jFe88","tabIcon":"styles_tabIcon__lHhNS","tabLabel":"styles_tabLabel__d90yj","content":"styles_content__Atsm5"};